import script from "./Livingroom.vue?vue&type=script&setup=true&lang=js"
export * from "./Livingroom.vue?vue&type=script&setup=true&lang=js"

import "./Livingroom.vue?vue&type=style&index=0&id=a9a00388&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9a00388"]])

export default __exports__